<div>
    @if (advFiltersService.currentScreen === SCREENS.ONE) {
    <cx-adv-filters-fields></cx-adv-filters-fields>
    }
    
    @if (advFiltersService.currentScreen === SCREENS.TWO) {
    <cx-adv-filters-creator (temp)="updateTemp($event)" (change)="onChange($event)" (apply)="onApply($event)">
    </cx-adv-filters-creator>
    }
    
    @if (advFiltersService.currentScreen === SCREENS.THREE) {
    <app-cx-adv-filters-list (temp)="updateTemp($event)" (updateview)="onUpdateView($event)" (create)="onCreateView($event)" (echange)="onChange($event)" (apply)="onApply($event)">
    </app-cx-adv-filters-list>
    }
    
    @if (advFiltersService.viewNameModal) {
    <cx-view-name-modal (close)="onViewModalClose($event)" (create)="onViewNameClose($event)"></cx-view-name-modal>
    }
</div>

<!-- @if (!advFiltersService.currentView.id && advFiltersService.currentScreen === SCREENS.THREE) {
<div class="action mt-3">
    <button (click)="onCreateView($event)" class="btn-bg btn-sm">Create view</button>
</div>
} -->